import type { FaireProductEntity } from "../../entity_types/product";

export const p_dfmyrrq47f: FaireProductEntity = {
  token: "p_dfmyrrq47f",
  type: "product",
  name: "4oz | Hydrating Body Oil - Geranium + Ylang Ylang",
  brandToken: "b_8cd234c4",
  brandName: "Palermo Body",
  imageUrl:
    "https://cdn.faire.com/fastly/fc5944c16f7f28cd4ebb78b654de816c80f78843336a2bcc997a52831977e94c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/251f81629228e7fe15418a2f0be19ef2841c63b0b34046d7cd43c0b2889c7247.png",
    "https://cdn.faire.com/fastly/5fdd5cfb7b6af095254859c470eda5f84996c92728aab893a3309bb56c689276.png",
    "https://cdn.faire.com/fastly/da8d6db46b9579cbca78caf25d7bd4ee4161cd5ad621e43053fa9a732cf20b79.jpeg",
    "https://cdn.faire.com/fastly/082da192fbec9e735c97337f5c87159bca2d5dfab53f35d9564908cd13565e55.jpeg",
  ],
  priceDollars: 43.83,
  description:
    "A grounding, fast-absorbing body oil with geranium and ylang ylang. Deeply moisturizing, non-greasy, and finished with a soft, silky feel.\n\nKey ingredients: rosehip, sweet almond, jojoba, geranium, and ylang ylang oils. Ideal for dry, sensitive, or maturing skin.\n\nVegan, cruelty-free, and handcrafted in small batches. 4oz bottle in a branded outer box, made for Mother's Day gifting, baby showers, and spa collections.",
  tags: [],
  msrpDollars: 87.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:42.116Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
